import { AddressSearchContainerControllerBase } from '../search/address_search_container_controller_base';

export default class extends AddressSearchContainerControllerBase {
  initialFocusElement() {
    return this.element.querySelector('input[name="search_fields[StreetNumberInteger][left]"]');
  }

  summarizeRow($row) {
    const splitVals = [];
    $row.find('.controls.split').each(function() {
      if ($(this).css('display') === 'none') return;

      $(this).find('input[type=text], input[type=date]').each(function() {
        const value = (($(this).val()) || '').toString().trim();
        if (value) splitVals.push(value);
      });
    });
    if (splitVals.length > 0) return splitVals.join(' - ');

    const relativeValue = ($row.find('input[name$="[relative_value]"]').val() || '').toString().trim();
    if (relativeValue.length > 0) {
      const relativeTime = ($row.find('input[name$="[relative_time]"]').val() || 'days').toString().trim();
      const relativeDirection = ($row.find('input[name$="[relative_direction]"]').val() || 'back').toString().trim();
      return `${relativeValue} ${relativeTime} ${relativeDirection}`;
    }

    const selected = [];
    $row.find('.controls select option:selected').each(function() {
      if ($(this).val()) selected.push($(this).text().trim());
    });
    if (selected.length > 0) return selected.join(', ');

    const checkedLabels = [];
    $row.find('.controls input[type=checkbox]:checked').each(function() {
      const label = $(this).closest('.field-wrapper').find('label').first().text().trim();
      if (label) checkedLabels.push(label);
    });
    if (checkedLabels.length > 0) return checkedLabels.join(', ');

    return ($row.find('.controls input[type=text]').first().val() || '').toString().trim();
  }
}
